import { useEffect, useState } from 'react';

/** Staged fade-and-rise, matching the entrance previous releases used.
 *  `count` is how many steps the caller wants to advance through. */
export function useStagedReveal(count: number, firstDelay = 100, step = 200): number {
    const [stage, setStage] = useState(0);

    useEffect(() => {
        setStage(0);
        const timers = Array.from({ length: count }, (_, i) =>
            setTimeout(() => setStage(i + 1), firstDelay + i * step)
        );
        return () => timers.forEach(clearTimeout);
    }, [count, firstDelay, step]);

    return stage;
}

// Plain shape rather than React's CSSProperties, which differs between the apps' csstype copies.
export interface RevealStyle {
    opacity: number;
    transform: string;
}

export function revealStyle(visible: boolean, distance = 16): RevealStyle {
    return {
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : `translateY(${distance}px)`
    };
}
